import { useFormContext, useWatch } from 'react-hook-form';
import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shigo-ui/ui';

import type { DemandPartnerFormValue } from '../../formSchema';
import { DemandPartnerGrossNet } from '../../model';

export function GrossNetField(props: {
  name: 'revShareGrossNet' | 'biddingGrossNet';
  label: string;
  hint?: string;
}) {
  const { control, setValue } = useFormContext<DemandPartnerFormValue>();
  const value = useWatch({ control, name: props.name });

  return (
    <DashboardPageFormField label={props.label} required hint={props.hint}>
      <Select
        value={value}
        onValueChange={(next) => {
          setValue(props.name, next as DemandPartnerGrossNet);
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={DemandPartnerGrossNet.Gross}>Gross</SelectItem>
          <SelectItem value={DemandPartnerGrossNet.Net}>Net</SelectItem>
        </SelectContent>
      </Select>
    </DashboardPageFormField>
  );
}
